import { Component, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpService } from '../../services/http.service';
import { AuthenService } from '../../services/authen.service';
import { HelperService } from '../../services/helper.service';
@Component({
    selector: '',
    templateUrl: './hs-matrix-v2-detail.html',
})
export class HSMatrixV2DetailComponent implements OnInit {
    subs: any = null;
    id: number = 0;
    item: any = null;
    requestTypeIdSelected: number = null;
    requestTypeList: any[] = [];
    nameValueFields: Object = { text: 'Name', value: 'Value' };

    constructor(private http: HttpService, private auth: AuthenService, private route: ActivatedRoute, private helper: HelperService, private router: Router) {
        this.subs = route.params.subscribe(params => {
            this.id = params['id'];
        })
    }

    ngOnDestroy() {
        this.subs.unsubscribe();
    }

    ngOnInit() {

        let idGet = (this.id == undefined || this.id == null) ? 0 : this.id;

        this.http.get('api/Util/GetAllRequestTypeList/', res => {
            this.requestTypeList = res.Result;
            this.load(idGet);
                
        }, null);
    }

    load(id: number) {
        this.http.get(`api/HsMatrixV2/GetHSMatrix/${id}`, res => {
            this.item = res.Result;
            this.requestTypeIdSelected = this.item.GroupRequestId;
        });
    }

    isInputValid() {
        let msg = null;
        if (this.item.HSUserCode == null) {
            msg = 'HS user code is required'
        }

        return msg;
    }

    onSave()
    {
        let err = this.isInputValid();
        if (err == null) {
            this.item.GroupRequestId = this.requestTypeIdSelected;
            this.http.save('api/HsMatrixV2/SaveHSMatrix', this.item, res => {
                this.load(res.ID);
                this.router.navigate(['/hs-matrix-v2-detail', res.ID]);
            });
        } else {
            this.helper.alertFailed(err);
        }
    }
}
